<div class="wrapper">
  <h1>Разработка</h1>
  <div class="actions">
    @for (developmentItem of developmentItems; track $index) {
      <div class="action">
        <h2 class="title">
          {{ developmentItem.category }}
        </h2>
        @for (item of developmentItem.items; track $index) {
          <app-development-page-line
            [developmentPageLineParams]="{
              title: item.title,
              text: getHref(item),
              href: getHref(item),
              btnText: item.btnText,
              type: item.type
            }"
          />
        }
      </div>
    }
    <div class="action">
      <h2 class="title">
        Сгенерировать отчеты
      </h2>
      <div class="line">
        <button
          mat-stroked-button
          color="warn"
          (click)="generateReports('day-reports')"
        >
          Сгенерировать отчеты
        </button>
        @if (isGenerate()) {
          <mat-spinner diameter="20"></mat-spinner>
        }
      </div>
      <div class="line">
        @switch (reportStatus()) {
          @case ('loading') {
            <div class="loading-message">
              Загрузка отчетов...
            </div>
          }
          @case ('success') {
            <div class="success-message">
              Отчеты успешно сгенерированы
            </div>
          }
          @case ('error') {
            <div class="error-message">
              Ошибка при генерации отчетов
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>
